<div class="dropdown">
  <div class="input" [ngStyle]="{'min-width.px': width, 'max-width.px': width, 'height.px': height}"
    [ngClass]="{'disabled': control.disabled, 'active': active}" (click)="toogleDropdown()">
    <div class="label">{{ control.value ? control.value : placeholder }}</div>

    <mat-spinner *ngIf="loading" [diameter]="20" [color]="'grey'"></mat-spinner>
    <mat-icon *ngIf="!active && !loading" fontIcon="expand_more"></mat-icon>
    <mat-icon *ngIf="active && !loading" fontIcon="expand_less"></mat-icon>
  </div>

  <div *ngIf="active" class="content show-up" [class.relative]="positionRelative"
    [ngStyle]="{'min-width.px': width, 'max-width.px': width}">
    <ul class="options">
      <li class="option" *ngFor="let option of options" (click)="selectOption(option)">
        <span *ngIf="multiple" class="checkbox" [ngClass]="{'selected': option.selected}"></span>
        <div>{{ option.label }}</div>
      </li>

    </ul>
  </div>
</div>

<div *ngIf="active" (click)="toogleDropdown()" class="dropdown-container"></div>
